import cn from 'clsx'
import { CaretDownIcon } from '../icons'
import type {
    TNavigationMenuItemProps,
    TNavigationMenuListProps,
    TNavigationMenuProps,
    TNavigationMenuTriggerProps,
} from './NavigationMenu.types'
import styles from './NavigationMenu.module.css'

export const NavigationMenuPlaceholder = ({
    className,
    role,
    'aria-label': ariaLabel,
    children,
}: TNavigationMenuProps) => (
    <nav
        className={cn(styles.root, className)}
        role={role}
        aria-label={ariaLabel}
        data-orientation="horizontal"
    >
        {children}
    </nav>
)

export const NavigationMenuListPlaceholder = ({
    className,
    children,
}: TNavigationMenuListProps) => (
    <div>
        <ul className={cn(styles.list, className)} data-orientation="horizontal">
            {children}
        </ul>
    </div>
)

export const NavigationMenuItemPlaceholder = ({
    className,
    children,
    ...props
}: TNavigationMenuItemProps) => (
    <li className={cn(styles.item, className)} {...props}>
        {children}
    </li>
)

export const NavigationMenuTriggerPlaceholder = ({
    className,
    children,
    showIcon = true,
}: TNavigationMenuTriggerProps) => (
    <button
        type="button"
        className={cn(styles.trigger, className)}
        aria-expanded={false}
        data-state="closed"
    >
        {children}
        {showIcon ? <CaretDownIcon className={styles.icon} aria-hidden="true" /> : null}
    </button>
)
